import { render, staticRenderFns } from "./ReportMobileRestaurants.vue?vue&type=template&id=19272798"
import script from "./ReportMobileRestaurants.vue?vue&type=script&lang=js"
export * from "./ReportMobileRestaurants.vue?vue&type=script&lang=js"
import style0 from "./ReportMobileRestaurants.vue?vue&type=style&index=0&id=19272798&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports